import { render, staticRenderFns } from "./TransRadialChart.vue?vue&type=template&id=34969091&scoped=true&"
import script from "./TransRadialChart.vue?vue&type=script&lang=js&"
export * from "./TransRadialChart.vue?vue&type=script&lang=js&"
import style0 from "./TransRadialChart.vue?vue&type=style&index=0&id=34969091&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34969091",
  null
  
)

export default component.exports